var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49998 0.5V1.33333H0.333313V3H1.16665V13.8333C1.16665 14.2754 1.34224 14.6993 1.6548 15.0118C1.96736 15.3244 2.39129 15.5 2.83331 15.5H11.1666C11.6087 15.5 12.0326 15.3244 12.3452 15.0118C12.6577 14.6993 12.8333 14.2754 12.8333 13.8333V3H13.6666V1.33333H9.49998V0.5H4.49998ZM4.49998 4.66667H6.16665V12.1667H4.49998V4.66667ZM7.83331 4.66667H9.49998V12.1667H7.83331V4.66667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.fb6cf9eb41d01458c0daa14654bba581.svg";
export { ForwardRef as ReactComponent };